// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._8ljb8b0 {
  border-bottom: 2px solid var(--_18w76bw2w);
  margin: 0px 90px;
}
._8ljb8b1 {
  margin: 30px 20px 0px;
}
._8ljb8b2 {
  border-top: 2px solid var(--_18w76bw28);
}
@media screen and (min-width: 768px) {
  ._8ljb8b0 {
    margin: 0px 250px;
  }
  ._8ljb8b1 {
    max-width: 85%;
    margin: 30px auto 0;
  }
  ._8ljb8b3 {
    max-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uCAAuC;AACzC;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["._8ljb8b0 {\n  border-bottom: 2px solid var(--_18w76bw2w);\n  margin: 0px 90px;\n}\n._8ljb8b1 {\n  margin: 30px 20px 0px;\n}\n._8ljb8b2 {\n  border-top: 2px solid var(--_18w76bw28);\n}\n@media screen and (min-width: 768px) {\n  ._8ljb8b0 {\n    margin: 0px 250px;\n  }\n  ._8ljb8b1 {\n    max-width: 85%;\n    margin: 30px auto 0;\n  }\n  ._8ljb8b3 {\n    max-width: 220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
